import React, { useState, memo, useCallback, useEffect } from 'react';
import SearchFilter from 'b2b-ui-components-lib/lib/components/searchFilter';
import { SEARCH_OPTIONS, BULK_UPGRADE_SEARCH_OPTIONS } from '../configure-plan-pricing-constant';
import debounce from 'lodash.debounce';
import { isFunction } from 'common/utils/validator';
import { isBulkUpgrade } from 'common/constants/app.constants';

const CustomSearchFilter = ({ searchValue, setSearchValue, searchType, SetSearchType }) => {
  const [searchText, setSearchText] = useState(searchValue);
  const updateOnSearch = useCallback(debounce(setSearchValue, 500), []);
  const onSearchValueChange = (value) => {
    if (searchType && searchType.hasOwnProperty('validator') && isFunction(searchType.validator) && searchType.validator(value)) {
      setSearchText(value);
    }
  };

  const onSearchTypeChange = (searchType) => {
    SetSearchType(searchType);
    setSearchText('');
  };

  const onSearchClick = () => {
    onSearchValueChange(searchText);
  };

  useEffect(() => {
    updateOnSearch(searchText);
  }, [searchText]);

  return (
    <SearchFilter
      searchType={searchType}
      onSearchTypeChange={onSearchTypeChange}
      searchTypeOptions={isBulkUpgrade() ? BULK_UPGRADE_SEARCH_OPTIONS : SEARCH_OPTIONS}
      searchValue={searchText}
      onSearchValueChange={onSearchValueChange}
      filterOptions={{
        BANDWIDTH: [],
        MEDIA: []
      }}
      placeholder="Enter here..."
      variant="compact"
      onSearchClick={onSearchClick}
    />
  );
};

export default memo(CustomSearchFilter);
